import React,{ Component } from 'react';
import {Modal, Table, Checkbox, Form, Input, Row, Col} from 'antd'

const columns = [
    {
        title: 'PO Number',
        dataIndex: 'poNumber',
    },
    {
        title: 'Item No.',
        dataIndex: 'invoiceItemNo',
    },
    {
        title: 'Part Number',
        dataIndex: 'partNumber',
    },
    {
        title: 'Description',
        dataIndex: 'partNumberDesc',
    },
    {
        title: 'Billed Quantity',
        dataIndex: 'quantity',
    },
    {
        title: 'SU',
        dataIndex: 'salesUnit',
    },
    {
        title: 'Net Value',
        dataIndex: 'netValue',
    },
    {
        title: 'Net Price',
        dataIndex: 'netValueUnit',
    },
    {
        title: 'Currency',
        dataIndex: 'currency',
    },
    {
        title: 'Sales Order',
        dataIndex: 'orderNumber',
    },
    // {
    //     title: 'Sales Order Item',
    //     dataIndex: 'orderItemNumber',
    // },
    {
        title: 'Delivery',
        dataIndex: 'deliveryNumber',
    },
    // {
    //     title: 'Delivery Item',
    //     dataIndex: 'deliveryItemNumber',
    // },
];

class TableModel extends Component{
    constructor(props){
        super(props)
        this.state={
            invoice_number:this.props.ValidateData?this.props.ValidateData.invoiceNumber:'',
            data:this.props.ValidateData,
            soldToNumber:this.props.ValidateData?this.props.ValidateData.soldToNumber:'',
            shipToNumber:this.props.ValidateData?this.props.ValidateData.shipToNumber:'',
            billToNumber:this.props.ValidateData?this.props.ValidateData.billToNumber:'',
        }
    }
    rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        },
        getCheckboxProps: (record) => ({
            disabled: record.name === 'Disabled User',
            name: record.name,
        }),
    };
    componentWillReceiveProps(){
        this.setState({invoice_number:this.props.ValidateData.invoiceNumber})
        if(this.props.ValidateData){
            this.setState({
                data:this.props.ValidateData.invoiceItems,
                soldToNumber:this.props.ValidateData.soldToNumber,
                shipToNumber:this.props.ValidateData.shipToNumber,
                billToNumber:this.props.ValidateData.billToNumber,
            })
        }

    }
    render(){
        const {invoice_number,soldToNumber,shipToNumber,billToNumber} = this.state
        return <Modal width={1200} title="Select Part Number"
                      destroyOnClose={true}
                      visible={this.props.isModalVisible}
                      onOk={this.props.callback}
                      onCancel={this.props.handleCancel}>
            <Form
                labelCol={{ span:8 }}
                wrapperCol={{ span: 12}}
                preserve={false}>
                <Row>
                    <Col span={12}>
                        <Form.Item
                            label="Invoice Number"
                            name={'invoiceNumber'}
                            rules={[{ required: false }]}
                        >
                            <Input defaultValue={invoice_number} disabled />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Sold To"
                            name={'soldToNumber'}
                            rules={[{ required: false }]}
                        >
                            <Input defaultValue={soldToNumber+' '+this.props.ValidateData.soldToName} disabled />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Ship To"
                            name={'shipToNumber'}
                            rules={[{ required: false }]}
                        >
                            <Input defaultValue={shipToNumber+' '+this.props.ValidateData.shipToName} disabled />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label="Bill To"
                            name={'billToNumber'}
                            rules={[{ required: false }]}
                        >
                            <Input defaultValue={billToNumber+' '+this.props.ValidateData.billToName} disabled />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            {
                this.props.type===3?
                    <p>
                        <b style={{color:'red'}}>
                            All the selected items’ Billed Quantity would be fully populated into the submission form, please pay attention, thanks!
                        </b>
                    </p>:''
            }
            <Table
                scroll={{ x: 1500 ,y: 500}}
                rowSelection={{
                    type: Checkbox,
                    onChange:this.props.dataChecked,
                    selectedRowKeys: this.props.selectedRowKeys,
                    getCheckboxProps: (record) => ({
                        disabled: record.name === 'Disabled User',
                        name: record.name,
                    }),
                }}
                rowKey={'invoiceItemNo'}
                columns={columns}
                dataSource={this.state.data}
            />
        </Modal>
    }

}

export default TableModel

